<template>
  <a :href="link.short_url" :title="link.url" target="_blank">
    <div class="card">
      <div class="card-image">
        <figure v-if="meta && meta.image" class="image">
          <img v-if="meta && meta.image" :src="meta.image" alt="">
        </figure>
        <figure v-else class="image is-flex is-align-items-center is-justify-content-center">
          <b-icon icon="image" type="is-light" style="font-size: 18rem;" />
        </figure>
      </div>
      <div class="card-content" v-observe-visibility="{ callback: visChanged, once: true, throttle: 300 }">
        <div class="content">
          <div v-if="meta && meta.title"><strong>{{ meta.title }}</strong></div>
          <p v-if="meta && meta.description">{{ meta.description }}</p>
        </div>
        <small class="has-text-grey">
          <b-icon icon="link"></b-icon> {{ link.display_url }}
        </small>
      </div>
    </div>
  </a>
</template>

<script>
import _ from 'lodash'
import tweets from "../../api/tweets"

export default {
  name: "TweetLink",
  props: {
    link: Object,
    loadOnMount: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      meta: undefined
    }
  },

  watch: {
    link(newVal, oldVal) {
      if (newVal.url !== oldVal.url) {
        this.meta = undefined
        this.loadMeta()
      }
    }
  },


  mounted() {
    // payload came with meta - set local prop
    if (this.link.meta) {
      this.meta = this.link.meta
    } else if (this.loadOnMount) {
      this.loadMeta()
    }
  },

  methods: {
    visChanged(isVisible) {
      // if brought into viewport and dont have meta, call API to get it
      if (isVisible && !this.meta) {
        this.loadMeta()
      }
    },
    loadMeta() {
      let url = this.link.url
      if (!_.startsWith(url, 'http://') && !_.startsWith(url, 'https://')) {
        url = 'http://' + url
      }
      if (!this.link.display_url) {
        // if we are doing a manual link from compose, we wont have a
        // display URL from twitter's API, so we make our own. It seems
        // that the Twitter system removes protocol and www, and then
        // truncates to 29 chars with an ellipsis character
        this.link.display_url = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")
        if (this.link.display_url.length > 30) {
          this.link.display_url = this.link.display_url.substr(0, 29) + '…'
        }
      }


      tweets.linkMeta(url).then(response => {
        // check the request_url we get back still matches what we sent
        // - because maybe by time the request has complete, it has changed
        if (url === response.data['request_url']) {
          this.meta = response.data
        }
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>

.card {
  border-radius: 0.5rem;
  height: 24rem;
}

.card-image figure {
  position: relative;
  height: 16rem;
  overflow: hidden;

  /* position image in the middle of a fixed height figure */
  /* https://stackoverflow.com/questions/14562457/center-oversized-image-in-div/41059954 */
  img {
    position: absolute;
    top: -9999px;
    bottom: -9999px;
    left: -9999px;
    right: -9999px;
    margin: auto;
  }
}
.card-content {
  padding: 0.5rem;
  height: 8rem;
  margin-bottom: 0.5rem;
  p {
    height: 2.8rem;
    overflow: hidden;
  }
  .content {
    height: 4.5rem;
    overflow: hidden;
    margin-bottom: 0.5rem;
  }
}

.content figure {
  margin-left: 0;
  margin-right: 0;
}
</style>
